module.exports = __webpack_public_path__ + "static/artwork-caption-bg-8ec9dee504cb6af8e33908031e3786a8.svg";